import React, { Component } from 'react';
import config from '../configs/siteConfig'


class Footer extends Component {

  render() {
    return (
      <footer className="bg-dark-grey border-top p-3 text-muted small">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-12">
                <div>
                    <span className="navbar-brand"><strong>{config.siteTitleMeta}</strong></span>
                    <span>Copyright ©2019 {config.siteTitleMeta}</span>
                </div>
              </div>
            </div>
          </div>
      </footer>
    )
  }
}

export default Footer
